<template>
  <section class="section">
    <div class="container">
      <BaseTitle>
        Inscription
      </BaseTitle>

      <PendingAction />

      <form
        class="m-auto max-w-2xl"
        @submit.prevent="submit"
      >
        <div class="columns">
          <div class="column">
            <b-field label="Prénom*">
              <b-input
                v-model="firstname"
                placeholder="Henri"
                required
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Nom*">
              <b-input
                v-model="lastname"
                placeholder="Dupont"
                required
              />
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <b-field label="Email*">
              <b-input
                v-model="email"
                type="email"
                placeholder="henri.dupont@exemple.fr"
                required
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Téléphone*">
              <b-input
                v-model="phone_number"
                type="tel"
                placeholder="06 12 34 56 78"
                required
              />
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Société*">
              <b-input
                v-model="company"
                placeholder="Uniformatic"
                required
              />
            </b-field>
          </div>
          <div class="column">
            <b-field label="Activité*">
              <b-select
                v-model="activity"
                required
                placeholder="Activité"
                expanded
              >
                <option
                  v-for="activity in activities"
                  :key="activity"
                >
                  {{ activity }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field label="Commentaires">
              <b-input
                v-model="comment"
                type="textarea"
                placeholder="Commentaires"
                rows="3"
              />
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <p
              class="text-sm"
            >
              Les champs marqués d'un * sont obligatoires
            </p>
            <div class="field is-grouped is-grouped-centered mt-4">
              <p class="control">
                <b-button
                  native-type="submit"
                  type="is-primary"
                >
                  <strong>
                    Demander l'ouverture de mon compte
                  </strong>
                </b-button>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

import { mapActions, mapState } from 'vuex';
import BaseTitle from '../components/BaseTitle.vue';
import PendingAction from './partials/PendingAction.vue';
import { ACTIVITIES } from '../constants';

export default {
  name: 'SignUp',
  components: {
    BaseTitle,
    PendingAction,
  },
  data() {
    return { activities: ACTIVITIES };
  },
  computed: {
    ...mapFields('authentication', [
      'form.firstname',
      'form.lastname',
      'form.email',
      'form.company',
      'form.activity',
      'form.phone_number',
      'form.comment',
    ]),
    ...mapState('configuration', ['pendingAction']),
  },
  methods: {
    ...mapActions('authentication', ['signUp']),
    submit() {
      this.signUp().then(() => {
        if (!this.PendingAction) {
          const { redirect } = this.$route.query;
          this.$router.replace(redirect || '/inscription-effectuee');
        }
      }).catch((error) => {
        let message = 'Il y a eu une erreur lors de la création de votre compte. Veuillez contacter le service commercial.';
        if (error.response.status === 409) {
          message = 'Un compte avec cette adresse e-mail existe déjà.';
        }
        this.$buefy.toast.open({
          message,
          type: 'is-danger',
          position: 'is-bottom',
          duration: 5000,
        });
      });
    },
  },
};
</script>
